<div
  [ngClass]="{
    'input-field': true,
    'input-field--valid': valid,
    'input-field--invalid': invalid,
    'input-field--disabled': disabled,
  }"
>
  @if (label) {
    <label class="form-label" [htmlFor]="id">{{ label }}</label>
  }

  <div class="form-control-container">
    <div class="file-input-wrapper">
      <span class="file-text">Escolher arquivo</span>
      <span class="file-value">{{ fileName || this.placeholder }}</span>
      <input
        class="form-control"
        placeholder="{{ placeholder }}"
        accept=".xlsx,.xls,.csv"
        [id]="id"
        [type]="'file'"
        [disabled]="disabled"
        [(ngModel)]="value"
        (change)="onChangeInput($event)"
        (blur)="onTouchedInput()"
      />
    </div>

    <button type="button" class="upload-button">
      <p>Upload</p>
      <span class="material-symbols-outlined">upload</span>
    </button>
  </div>

  @if (control && control.errors && control.touched) {
    <cx-form-errors [control]="control" />
  } @else if (hintText) {
    <span class="form-hint-text">{{ hintText }}</span>
  } @else {
    <span class="description">FORMATOS .CSV .XLS .XLSX</span>
  }
</div>
